export default __webpack_public_path__ + "static/media/beach_2.25f35312.jpg";